export const RIGHT_BOUNDARY_INDEXES = [48, 96, 144]
export const LEFT_BOUNDARY_INDEXES = [47, 95, 143]
export const OUT_BOUNDARY_INDEXES = [-1, 192]
